export default function ($http) {
    return function (model) {
        return $http.post('api/accountGroups', model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/accountGroups/services/add/addAccountGroup.js